import { DATE_FORMAT, DATE_WITH_TIME_FORMAT } from '@utils/constants';
import { LEAD_DATA_TYPE, LeadEventOrTask, LeadEventsAndTasksList, OneEvent } from '@utils/models/LeadEventsAndTaskList';
import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';

export function getEvents(
  res: AxiosResponse<
    {
      data: LeadEventOrTask[];
    },
    any
  >,
  arr: LeadEventsAndTasksList[]
) {
  let list: LeadEventOrTask[] = [];
  let events: OneEvent[] = [];

  let date: string = res?.data?.data?.[0]?.timestamp
    ? dayjs.unix(Number(res?.data?.data?.[0]?.timestamp)).tz().format(DATE_FORMAT)
    : res?.data?.data?.[0]?.date || '';
  let eventDate: string = '';

  const data: LeadEventOrTask[] = res?.data?.data;

  const parseEvent = (event: OneEvent): OneEvent => ({
    ...event,
    date: event?.timestamp ? dayjs.unix(Number(event?.timestamp)).tz().format(DATE_WITH_TIME_FORMAT) : event?.date,
    createdDate: event?.createdTimestamp
      ? dayjs.unix(Number(event?.createdTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
      : event?.createdDate,
    closedDate: event?.closedTimestamp
      ? dayjs.unix(Number(event?.closedTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
      : event?.closedDate,
    deadlineStart: event?.deadlineStartTimestamp
      ? dayjs.unix(Number(event?.deadlineStartTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
      : event?.deadlineStart,
    deadlineFinish: event?.deadlineFinishTimestamp
      ? dayjs.unix(Number(event?.deadlineFinishTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
      : event?.deadlineFinish,
    ...(event?.events && {
      events: event?.events?.map(item => ({
        ...item,
        date: item?.timestamp ? dayjs.unix(Number(item?.timestamp)).tz().format(DATE_WITH_TIME_FORMAT) : item?.date,
        closedDate: item?.closedTimestamp
          ? dayjs.unix(Number(item?.closedTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : item?.closedDate,
        deadlineStart: item?.deadlineStartTimestamp
          ? dayjs.unix(Number(item?.deadlineStartTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : item?.deadlineStart,
        deadlineFinish: item?.deadlineFinishTimestamp
          ? dayjs.unix(Number(item?.deadlineFinishTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : item?.deadlineFinish
      }))
    }),
    ...(event?.chats && {
      chats: event?.chats?.map(chat => ({
        ...chat,
        createdDate: chat?.createdTimestamp
          ? dayjs.unix(Number(chat?.createdTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : chat?.createdDate
      }))
    }),
    ...(event?.leadDto && {
      leadDto: {
        ...event?.leadDto,
        createdDate: event?.leadDto?.createdTimestamp
          ? dayjs.unix(Number(event?.leadDto?.createdTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : event?.leadDto?.createdDate
      }
    }),
    ...(event?.paymentDto && {
      paymentDto: {
        ...event?.paymentDto,
        createdDate: event?.paymentDto?.createdTimestamp
          ? dayjs.unix(Number(event?.paymentDto?.createdTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : event?.paymentDto?.createdDate,
        canceledDate: event?.paymentDto?.canceledTimestamp
          ? dayjs.unix(Number(event?.paymentDto?.canceledTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : event?.paymentDto?.canceledDate
      }
    }),
    ...(event?.contractShortDto && {
      contractShortDto: {
        ...event?.contractShortDto,
        createdDate: event?.contractShortDto?.createdTimestamp
          ? dayjs.unix(Number(event?.contractShortDto?.createdTimestamp)).tz().format(DATE_WITH_TIME_FORMAT)
          : event?.contractShortDto?.createdDate
      }
    })
  });

  for (let i = 0; i < data.length; i++) {
    const indexDate = data?.[i].res.timestamp
      ? dayjs.unix(Number(data?.[i].timestamp)).tz().format(DATE_FORMAT)
      : data?.[i].res.date ||
        (data?.[i].timestamp ? dayjs.unix(Number(data?.[i].timestamp)).tz().format(DATE_FORMAT) : data?.[i].date);

    if (data.length === i + 1) {
      if (data[i].leadDataType !== LEAD_DATA_TYPE.LEAD_EVENT) {
        if (events.length > 0) {
          list.push({
            ...data[i],
            date: indexDate,
            events: events?.map(parseEvent),
            res: parseEvent(data[i].res),
            leadDataType: LEAD_DATA_TYPE.LEAD_EVENT
          });
          events = [];
          eventDate = '';
        }
        list.push({
          ...data[i],
          date: indexDate,
          events: data?.[i]?.events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
      } else if (eventDate === indexDate) {
        events.push(parseEvent(data[i].res));
        list.push({
          ...data[i],
          date: indexDate,
          events: events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
      } else {
        if (events.length > 0) {
          list.push({
            ...data[i],
            date: indexDate,
            events: events?.map(parseEvent),
            res: parseEvent(data[i].res),
            leadDataType: LEAD_DATA_TYPE.LEAD_EVENT
          });
          events = [];
          eventDate = '';
        }
        events.push(parseEvent(data[i].res));
        list.push({
          ...data[i],
          date: indexDate,
          events: events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
      }
      arr.push({
        date,
        events: list
      });
    } else if (indexDate === date) {
      if (data[i].leadDataType !== LEAD_DATA_TYPE.LEAD_EVENT) {
        if (events.length > 0) {
          list.push({
            ...data[i],
            date: indexDate,
            events: events?.map(parseEvent),
            res: parseEvent(data[i].res),
            leadDataType: LEAD_DATA_TYPE.LEAD_EVENT
          });
          events = [];
          eventDate = '';
        }
        list.push({
          ...data[i],
          date: indexDate,
          events: data?.[i]?.events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
      } else if (eventDate === indexDate) {
        events.push(parseEvent(data[i].res));
      } else {
        if (events.length > 0) {
          list.push({
            ...data[i],
            date: indexDate,
            events: events?.map(parseEvent),
            res: parseEvent(data[i].res),
            leadDataType: LEAD_DATA_TYPE.LEAD_EVENT
          });
        }
        events = [];
        events.push(parseEvent(data[i].res));
        eventDate = indexDate;
      }
    } else {
      if (events.length > 0) {
        list.push({
          leadDataType: LEAD_DATA_TYPE.LEAD_EVENT,
          date,
          events: events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
        events = [];
        eventDate = '';
      }
      if (data[i].leadDataType !== LEAD_DATA_TYPE.LEAD_EVENT) {
        arr.push({
          date,
          events: list
        });
        date = indexDate;
        list = [];
        list.push({
          ...data[i],
          date: indexDate,
          events: data?.[i]?.events?.map(parseEvent),
          res: parseEvent(data[i].res)
        });
      } else {
        arr.push({
          date,
          events: list
        });
        date = indexDate;
        list = [];
        events.push(parseEvent(data[i].res));
        eventDate = indexDate;
      }
    }
  }
}
